import { useCountry } from "./useCountry";

/**
 * Pricing is in USD everywhere; the "USD" currency label is shown only to
 * visitors outside the US. Reads the visitor country from the `country`
 * cookie via `useCountry` (returns "US" on the server / first client render,
 * then updates after hydration) so US visitors never see the label.
 *
 * @param {boolean} [showCurrencyCode=true] Per-page/opt-out switch.
 * @returns {boolean} Whether to render the USD label.
 */
export function useShowCurrencyLabel(showCurrencyCode = true) {
  const country = useCountry();
  return showCurrencyCode && country !== "US";
}
